import * as fromAccount from './account.reducer';
import * as fromReferer from './referer.reducer';
import * as fromSetPassword from './set-password.reducer';
import * as fromChangeEmail from './change-email.reducer';
import * as fromUnusualLogin from './unusual-login.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const FEATURE_NAME = 'Account';

export interface IAccountsState {
  account: fromAccount.IState;
  referer: fromReferer.IState;
  setPassword: fromSetPassword.IState;
  changeEmail: fromChangeEmail.IState;
  unusualLogin: fromUnusualLogin.IState;
}

export const reducer = {
  account: fromAccount.reducer,
  referer: fromReferer.reducer,
  setPassword: fromSetPassword.reducer,
  changeEmail: fromChangeEmail.reducer,
  unusualLogin: fromUnusualLogin.reducer,
};

// Selectors
const selectFeature = createFeatureSelector<IAccountsState>(FEATURE_NAME);

export const getTrackingObject = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.trackingObject
);
export const isAccountRegistering = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.registering
);
export const isAccountRegistered = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.registered
);
export const getAccount = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.account
);
export const getUserAccount = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.userAccount
);
export const getUserEmail = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.userEmail
);
export const getAccountError = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.error
);
export const getAccountRegistrationType = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.registrationType
);
export const getReturnUrl = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.returnUrl
);
export const isAccountLoggingIn = createSelector(
  selectFeature,
  (state: IAccountsState) => state.account.loggingIn
);

export const isRefererLoading = createSelector(
  selectFeature,
  (state: IAccountsState) => state.referer.loading
);
export const isRefererLoaded = createSelector(
  selectFeature,
  (state: IAccountsState) => state.referer.loaded
);
export const getReferralCode = createSelector(
  selectFeature,
  (state: IAccountsState) => state.referer.referralCode
);
export const getReferer = createSelector(
  selectFeature,
  (state: IAccountsState) => state.referer.referer
);
export const getRefererError = createSelector(
  selectFeature,
  (state: IAccountsState) => state.referer.error
);

export const getSetPasswordMessage = createSelector(
  selectFeature,
  (state: IAccountsState) => state.setPassword.message
);
export const getSetPasswordError = createSelector(
  selectFeature,
  (state: IAccountsState) => state.setPassword.error
);
export const isSetPasswordProcessing = createSelector(
  selectFeature,
  (state: IAccountsState) => state.setPassword.processing
);
export const getSetPasswordToken = createSelector(
  selectFeature,
  (state: IAccountsState) => state.setPassword.token
);

export const getChangeEmailToken = createSelector(
  selectFeature,
  (state: IAccountsState) => state.changeEmail.token
);

export const getChallenge = createSelector(
  selectFeature,
  (state: IAccountsState) => state.unusualLogin.challenge
);
export const getUnusualLoginMessage = createSelector(
  selectFeature,
  (state: IAccountsState) => state.unusualLogin.message
);
export const getUnusualLoginError = createSelector(
  selectFeature,
  (state: IAccountsState) => state.unusualLogin.error
);
export const getLoginAttemptResult = createSelector(
  selectFeature,
  (state: IAccountsState) => state.unusualLogin.loginAttemptResult
);
